import DateTimePickerModal from 'react-native-modal-datetime-picker';
import i18n from '@/utils/i18n';
import React from 'react';
import { Platform } from 'react-native';

type MinuteInterval = React.ComponentProps<
  typeof DateTimePickerModal
>['minuteInterval'];

interface TimePickerModalProps {
  accessibilityLabel: string;
  minimumDate?: Date;
  minuteInterval?: MinuteInterval;
  onCancel: () => void;
  onConfirm: (time: Date) => void;
  time: Date;
}

export const TimePickerModal: React.FC<TimePickerModalProps> = ({
  accessibilityLabel,
  minimumDate,
  minuteInterval,
  onCancel,
  onConfirm,
  time,
}) => (
  <DateTimePickerModal
    accessibilityLabel={accessibilityLabel}
    cancelTextIOS={i18n.t('cancel')}
    confirmTextIOS={i18n.t('done')}
    date={time}
    display={Platform.OS === 'ios' ? 'spinner' : 'default'}
    is24Hour={false}
    isVisible
    minimumDate={minimumDate}
    minuteInterval={Platform.OS === 'ios' ? minuteInterval : undefined}
    mode="time"
    onCancel={onCancel}
    onConfirm={onConfirm}
  />
);
